import IconWeb from "/src/assets/img/svg/web.svg";
import IconPhone from "/src/assets/img/svg/telephony.svg";
import IconRcs from "/src/assets/img/svg/rcs.svg";
import IconWhatsapp from "/src/assets/img/svg/whatsapp.svg";
import IconMessenger from "/src/assets/img/svg/mail.svg";
import IconTransfer from "/src/assets/img/svg/telephony_transfer.svg";
export default {
    web : IconWeb,
    telephony : IconPhone,
    messenger:IconMessenger,
    rcs : IconRcs,
    // No WhatsApp channel exists yet: this icon only serves the announced selector entry.
    whatsapp : IconWhatsapp,
    telephony_transfer : IconTransfer
}